import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Counter } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
import Playground from '@components/Playground';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "counter"
    }}>{`Counter`}</h1>
    <p>{`Used for interactively changing count`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    import {'{ Counter }'} from '@cleartrip/bento'
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={1} __code={''} __scope={{
      props,
      DefaultLayout,
      Counter,
      Sandbox,
      Playground,
      DefaultLayout,
      _frontmatter
    }} code="<Counter />" scope={{
      Counter
    }} mdxType="Playground" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      